import Flickity from 'flickity';

const arrowShape =
  'M50.63,83.06c-2.64,2.64-2.64,6.92,0,9.56,2.64,2.64,6.92,2.64,9.56,0l37.84-37.84c1.27-1.27,1.98-2.99,1.98-4.78s-.71-3.51-1.98-4.78L60.18,7.38c-2.64-2.64-6.92-2.64-9.56,0-2.64,2.64-2.64,6.92,0,9.56l26.3,26.3H6.76c-3.73,0-6.76,3.02-6.76,6.76s3.03,6.76,6.76,6.76h70.17l-26.3,26.3Z';

const createLightbox = () => {
  const lightbox = document.createElement('div');
  lightbox.className = 'package-gallery-lightbox';
  lightbox.setAttribute('aria-hidden', 'true');

  lightbox.innerHTML = `
    <div class="package-gallery-lightbox__backdrop" data-close-lightbox></div>
    <div class="package-gallery-lightbox__content" role="dialog" aria-modal="true">
      <button type="button" class="package-gallery-lightbox__close" aria-label="Sluit afbeelding">
        <span aria-hidden="true">&times;</span>
      </button>
      <img src="" alt="" class="package-gallery-lightbox__image" />
    </div>
  `;

  document.body.appendChild(lightbox);
  return lightbox;
};

document.addEventListener('DOMContentLoaded', () => {
  const lightbox = createLightbox();
  const lightboxImage = lightbox.querySelector(
    '.package-gallery-lightbox__image',
  );
  const closeButton = lightbox.querySelector(
    '.package-gallery-lightbox__close',
  );
  const closeBackdrop = lightbox.querySelector('[data-close-lightbox]');

  const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightboxImage.setAttribute('src', '');
    lightboxImage.setAttribute('alt', '');
  };

  const openLightbox = (imageSrc, imageAlt) => {
    if (!imageSrc) return;
    lightboxImage.setAttribute('src', imageSrc);
    lightboxImage.setAttribute('alt', imageAlt || '');
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
  };

  closeButton.addEventListener('click', closeLightbox);
  closeBackdrop.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });

  document.querySelectorAll('.package-gallery__zoom-btn').forEach((button) => {
    button.addEventListener('click', () => {
      const image = button.querySelector('img');
      openLightbox(
        button.dataset.fullSrc || image?.currentSrc || image?.src || '',
        button.dataset.alt || image?.alt || '',
      );
    });
  });

  document.querySelectorAll('.package-gallery').forEach((gallery) => {
    const items = gallery.querySelectorAll('.package-gallery__item');
    if (items.length <= 1) return;

    const flkty = new Flickity(gallery, {
      pageDots: false,
      arrowShape,
      cellAlign: 'center',
      prevNextButtons: true,
    });

    const thumbs =
      gallery.parentElement?.querySelectorAll('.package-gallery-thumb') || [];
    if (thumbs.length) {
      const setActiveThumb = (index) => {
        thumbs.forEach((el, i) => el.classList.toggle('active', i === index));
      };

      setActiveThumb(0);

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          flkty.select(index);
        });
      });

      flkty.on('change', setActiveThumb);
    }

    flkty.resize();
  });
});
